// view current users active invite to be able to respond
const state = {
  currentNotification: null,
  lastCurrentNotification: null,
};

const getters = {
  getCurrentNotification: (state) => {
    //don't show current room invit popup if you have already respondedd
    return state.currentNotification
  },
  getLastCurrentNotification: (state) => {
    return state.lastCurrentNotification
  },

  isActiveRoomInvite: () => (n) => {
    return !n.response && n.type === 'roomInvite' && n.sentOrReceived === 'received' && n.status === 'sent' ? true : false
  },
  getActiveRoomInvites: (state, getters) => {
    let received = [...getters.getUserNotifications]
    received = received.filter(n => getters.isActiveRoomInvite(n))
    return received.reverse() //oldest invite shown before most recent
  },
  isDeclinedRoomInvite: () => (n) => {
    return n.type === 'roomInvite' && n.sentOrReceived === 'sent' && (n.status === 'declined' || n.status === 'custom') ? true : false
  },
  getDeclinedRoomInvites: (state, getters) => {
    let sent = [...getters.getSentNotifications]
    sent = sent.filter(n => getters.isDeclinedRoomInvite(n))
    return sent.reverse() //oldest invite shown before most recent
  },
  ifPinnedUserJoinedCurrentRoom: (state, getters) => (n) => {
    return n.status === 'pinsUpdated' && n?.data?.pinnedUserSpaceId === getters.getCurrentUsersRoomId && !getters.getIfCurrentUsersRoomIsHub
  },
  isActivePin: () => (n) => {
    return n.status === 'pinsUpdated' && n.response === 'Available' ? true : false
  },
  getActivePinnedUsers: (state, getters) => {
    let received = [...getters.getUserNotifications]
    received = received.filter(n => getters.isActivePin(n))
    return received.reverse() //oldest active pin shown before most recent
  },
};

const mutations = {
  setCurrentNotification(state, data) {
    state.currentNotification = data;
  },
  setLastCurrentNotification(state, data) {
    state.lastCurrentNotification = data;
  },
};

const actions = {
  async setCurrentNotificationState({getters, commit, dispatch}, data) {
    if(data === getters.getLastCurrentNotification) return //dont show same popup again (when closing popup and checking for next active invite)
    if(getters.getCurrentNotification) { //clear before setting so that comp (popup) destroys not updated with new id causing conflict with showing next
      await dispatch('clearCurrentNotification', true)
    }
    commit('setCurrentNotification', data)
    commit('setLastCurrentNotification', data)
  },
  async clearCurrentNotification({getters, commit, dispatch}, dontCheckNext = false) {
    if(!getters.getCurrentNotification) return //dont update if dont need to

    let current = Object.assign({}, getters.getCurrentNotification) //do this here before its cleared in set current notification
    commit('setCurrentNotification', null);
    dispatch('updateInviteFavicon')

    //show next notification in queue
    if(dontCheckNext) return
    setTimeout(async () => {
      await dispatch('checkForActiveInvite', current)
      commit('setLastCurrentNotification', null)
    }, 1500)
  },

  async updateCurrentNotification({dispatch, rootGetters, getters}, data) {
    // Create a new current notification, or update the existing one
    const shouldUpdateExistingNotification = data.id == getters.getCurrentNotification?.id
    const meta = rootGetters['getNotificationMeta'](data)

    let showAsCurrent = false
    if(getters.ifPinnedUserJoinedCurrentRoom(data)) {
      showAsCurrent = false
      //cancel pin if a pinned user joins your room
      dispatch('cancelPinHandler', [data.data.pinsId])
    }
    else if(getters.isActivePin(data)) showAsCurrent = true
    else if(getters.isActiveRoomInvite(data)) showAsCurrent = true
    else if(getters.isDeclinedRoomInvite(data)) showAsCurrent = true

    let current = getters.getCurrentNotification

    //only show invites/pin updates when on area pages (not home/create area,etc)
    if(!meta || !getters.getCurrentAreaId || !showAsCurrent) { //close pin popup if user goes offline/status changes from available again
      if(current) {
        await dispatch('modal/close')
        if(data.id === current.id) dispatch('clearCurrentNotification') //only clear if same as current popup showing
      }
      return
    }

    //dont replace current notification if not same as current notification and if showing current
    if(!shouldUpdateExistingNotification && current) return console.log('dont replace current notification')

    dispatch('setCurrentNotificationState', data)

    if(!shouldUpdateExistingNotification) { //dont send again if same notification
      // This is a new notification
      dispatch('createNewDesktopNotification', meta.desktopNotification) // Create a desktop notification
      dispatch('openNotificationModal', data) // Open a modal, if it has one associated
    }

    dispatch('updateInviteFavicon')
  },
  async openNotificationModal({dispatch, rootGetters}, data) {
    const meta = rootGetters['getNotificationMeta'](data)

    if (meta.modalComponent) {
      dispatch('modal/open', [meta.modalComponent, {notificationId: data.id}], {root: true})
    }
  },

  async checkForActiveInvite({getters, dispatch}, dontRepeat = {id:null}) { //check for active invite in notifications list on load
    await dispatch('fetchNotifications')

    let active = getters.getActiveRoomInvites
    if(dontRepeat?.id) active = active.slice(active.indexOf(dontRepeat), active.length)
    if(active.length && active[0]?.id !== dontRepeat?.id) return dispatch('updateCurrentNotification', active[0]) //show oldest active invite first

    //check for pin updates
    let online = getters.getActivePinnedUsers
    if(dontRepeat?.id) online = online.slice(online.indexOf(dontRepeat), online.length)
    if(online.length && online[0]?.id !== dontRepeat?.id) return dispatch('updateCurrentNotification', online[0]) //show oldest active update first
  },

  updateInviteFavicon({getters}) {
    let hasNotification = getters.getCurrentNotification && getters.getCurrentNotification?.status === 'sent' && getters['routing/routeData']?.params?.areaId ? true : false
    let hasBroadcast = getters.activeBroadcast
    for(let f of [...document.querySelectorAll('.favicon')]){
      f.href = (!hasNotification && !hasBroadcast ? '/favicon/' : '/favicon_notification/')+f.dataset.file;
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
